<form 
        (ngSubmit)="$event.preventDefault(); saveGeneralKnowledge();"
        [formGroup]="generalKnowledgeForm"
        class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
    >
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            General Knowledge
        </h2>
        <div class="w-full flex flex-col items-center gap-4 pb-4">

            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>Rate the student's ability: Counting from 20 to 1 backward: *</p>
                </div>
                <div class="w-full flex items-start gap-2">
                    <div>
                        <input type="radio" id="rate_good" value="Good" class="hidden peer"
                                formControlName="student_counting">
                        <label for="rate_good"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            Good
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="rate_fair" value="Fair" class="hidden peer"
                                formControlName="student_counting">
                        <label for="rate_fair"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            Fair
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="rate_poor" value="Poor" class="hidden peer"
                                formControlName="student_counting">
                        <label for="rate_poor"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            Poor
                        </label>
                    </div>
                </div>
            </div>
            
            <div class="w-full flex flex-col items-start text-start" *ngFor="let question of questionList">
                <div class="w-full font-semibold">
                    <p>{{ question.question }}</p>
                </div>
                <div class="w-full flex items-start gap-2">
                    <div>
                        <input type="radio" [id]="question.formControlName + '_yes'" value="{{ yesNo.Yes }}" class="hidden peer" [formControlName]="question.formControlName">
                        <label [for]="question.formControlName + '_yes'"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                        Yes
                        </label>
                    </div>
                    <div>
                        <input type="radio" [id]="question.formControlName + '_no'" value="{{ yesNo.No }}" class="hidden peer" [formControlName]="question.formControlName">
                        <label [for]="question.formControlName + '_no'"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                        No
                        </label>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.generalKnowledgeForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.generalKnowledgeForm.valid
                }"
                [disabled]="this.generalKnowledgeForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>